import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventYellowRedCard extends DomainEvent<MatchEvent> {}
